import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'marketing/pk',
    name: 'MarketingPkList',
    component: () => import('@/pages/marketing-pk/index.vue'),
    meta: { title: 'PK活动', parent: '营销管理' },
  },
  {
    path: 'marketing/pk/create',
    name: 'MarketingPkCreate',
    component: () => import('@/pages/marketing-pk/create.vue'),
    meta: { title: '创建PK活动', parent: '营销管理' },
  },
  {
    path: 'marketing/pk/detail/:id',
    name: 'MarketingPkDetail',
    component: () => import('@/pages/marketing-pk/detail.vue'),
    meta: { title: 'PK活动详情', parent: '营销管理' },
  },
]

export default routes
